var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
export function Heading(_a) {
    var { className, level = 1 } = _a, props = __rest(_a, ["className", "level"]);
    let Element = `h${level}`;
    return (_jsx(Element, Object.assign({}, props, { className: clsx(className, 'text-2xl/8 font-semibold text-zinc-950 sm:text-xl/8 dark:text-white') })));
}
export function Subheading(_a) {
    var { className, level = 2 } = _a, props = __rest(_a, ["className", "level"]);
    let Element = `h${level}`;
    return (_jsx(Element, Object.assign({}, props, { className: clsx(className, 'text-base/7 font-semibold text-zinc-950 sm:text-sm/6 dark:text-white') })));
}
